
import React from 'react';
import { Loader2 } from 'lucide-react';

export const LoadingSpinner = () => {
  return (
    <div className="container mx-auto px-4 py-8 flex justify-center">
      <Loader2 className="h-12 w-12 animate-spin text-primary" />
    </div>
  );
};
